/** Distance from bottom (px) that still counts as “following” new messages. */
export const COACH_NEAR_BOTTOM_PX = 80;

export function isNearBottom(el, thresholdPx = COACH_NEAR_BOTTOM_PX) {
  if (!el) return true;
  const gap = el.scrollHeight - el.scrollTop - el.clientHeight;
  return gap <= thresholdPx;
}

/**
 * Decide whether auto-follow should stay on after a user scroll/wheel.
 * Programmatic scrolls must not call this (use ignore flag in the panel).
 */
export function stickAfterUserScroll(el, thresholdPx = COACH_NEAR_BOTTOM_PX) {
  return isNearBottom(el, thresholdPx);
}

/** Wheel up = user reading history → detach. Wheel down near bottom can reattach via scroll. */
export function stickAfterUserWheel(deltaY, currentlyStuck, el, thresholdPx = COACH_NEAR_BOTTOM_PX) {
  if (deltaY < 0) return false;
  if (deltaY > 0 && isNearBottom(el, thresholdPx)) return true;
  return currentlyStuck;
}

/** Instant pin — never use smooth here (smooth fights the user during typing). */
export function pinScrollToBottom(el) {
  if (!el) return;
  el.scrollTop = el.scrollHeight;
}
